import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@jwp/ott-theme/assets/icons/check.svg?react';
import Share from '@jwp/ott-theme/assets/icons/share.svg?react';
import useBreakpoint, { Breakpoint } from '@jwp/ott-ui-react/src/hooks/useBreakpoint';
import { useUIControls } from '@jwp/ott-hooks-react/src/useUIControls';

import { copyToClipboard } from '../../utils/clipboard';
import Button from '../Button/Button';
import Icon from '../Icon/Icon';
import { useTheme } from '../../../../../ThemeContext';

type Props = {
  title: string;
  description: string;
  url: string;
};

const ShareButton = ({ title, description, url }: Props) => {
  const { t } = useTranslation();
  const breakpoint = useBreakpoint();
  const { universalStyles } = useTheme();
  const [hasShared, setHasShared] = useState<boolean>(false);
  const { buttonIconOnly, buttonLabelOnly, buttonLabelWithIcon } = useUIControls();

  const onShareClick = async () => {
    if (typeof navigator.share === 'function') {
      await navigator.share({ title, text: description, url });
      return;
    }

    copyToClipboard(window.location.href);
    setHasShared(true);
    setTimeout(() => setHasShared(false), 2000);
  };

  return (
    <Button
      label={buttonLabelOnly || buttonLabelWithIcon ? (hasShared ? t('video:copied_url') : t('video:share')) : undefined}
      // color="videoDetailButton"
      variant="contained"
      size="exlarge"
      startIcon={buttonIconOnly || buttonLabelWithIcon ? hasShared ? <Icon icon={Check} /> : <Icon icon={Share} /> : undefined}
      onClick={onShareClick}
      active={hasShared}
      color={'primary'}
      fullWidth={breakpoint < Breakpoint.md}
      style={universalStyles.favoriteButtonBackground}
      textStyle={universalStyles.favoriteAndShareButtonText}
    />
  );
};

export default ShareButton;
